import { useDispatch } from "react-redux";
import { answerActivityQuestion } from "../../../redux/activityQuestions/activityQuestionsActions";
import { getDefaultQuestionValue } from "../utils/mapQuestions";
import isEqual from "lodash/isEqual";

const useAnswerQuestion = () => {
    const dispatch = useDispatch();

    return (value, question, followUpUUID) => {
        const defaultValue = getDefaultQuestionValue(question.questionType);
        const isAnswered = !isEqual(value, defaultValue);
        let formattedValue = "";

        if (question.questionType === "checkbox") {
            const selectedValues = question.props?.allowedValues?.filter((q) => value.includes(q.id));
            formattedValue = selectedValues?.reduce(
                (acc, curr) => {
                    acc.name_en = acc.name_en ? `${acc.name_en}, ${curr.name_en}` : curr.name_en;
                    acc.name_fr = acc.name_fr ? `${acc.name_fr}, ${curr.name_fr}` : curr.name_fr;
                    return acc;
                },
                { name_en: "", name_fr: "" },
            );
        } else if (question.questionType === "file" || question.questionType === "sketch") {
            const fileNames = value.map((file) => file.fileName).join(", ");
            formattedValue = { name_en: fileNames, name_fr: fileNames };
        } else {
            formattedValue = question.props?.allowedValues?.find((p) => p.id === value) ?? { name_en: value, name_fr: value };
        }

        dispatch(answerActivityQuestion(value, formattedValue, question.id, followUpUUID, isAnswered));
    };
};

export default useAnswerQuestion;
